
















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import BranchDto from '@/models/Branches/BranchDto';
import GiganautVue from '@/components/Shared/GiganautVue';
import Desk from '@/components/Desks/Desk.vue';
import DeskCreate from '@/components/Desks/DeskCreate.vue';
import BranchCreate from '@/components/Branches/BranchCreate.vue';
import BranchGeneralDetailsEdit from '@/components/Branches/BranchGeneralDetailsEdit.vue';
import BranchProfileDetailsEdit from '@/components/Branches/BranchProfileDetailsEdit.vue';
import BranchAddressDetailsEdit from '@/components/Branches/BranchAddressDetailsEdit.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import WorkerBulkInviteSearchRequest from '@/models/Workers/WorkerBulkInviteSearchRequest';


@Component({
  name: 'Branches',
  components: { BranchCreate, DeskCreate, BranchGeneralDetailsEdit, BranchProfileDetailsEdit, BranchAddressDetailsEdit, Desk }
})
export default class extends GiganautVue {
    
    public selectedItem: any =[];

    async beforeMount() {
        AgencySettingsModule.updateCurrentBranch(null);
    }

    @Watch("selectedItem")
    selectedItemChanged(val: any, oldVal: any) {
        if (val.length == 0) {
            AgencySettingsModule.updateCurrentBranch(null);
            AgencySettingsModule.updateCurrentDesk(null);
        } else {
            if (val[0].isBranch) {
                AgencySettingsModule.updateCurrentBranch(val[0]);
            } else {
                //We need to set the branch by looking at the desk
                const desk = val[0];
                const branchIndex = AgencySettingsModule.branches.findIndex((findBranch: BranchDto) => desk.branchId === findBranch.id);
                AgencySettingsModule.updateCurrentBranch(AgencySettingsModule.branches[branchIndex]);
                AgencySettingsModule.updateCurrentDesk(val[0]);
            }
        }
    }

    get currentBranch() {
        return AgencySettingsModule.currentBranch;
    }

    get currentDesk() {
        return AgencySettingsModule.currentDesk;
    }

    get loadingBranches() {
        return AgencySettingsModule.loadingBranches;
    }

    get branches() {
        return AgencySettingsModule.branches;
    }
}
